// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__wjZPu","description":"PatientConsentPreview_description__2Z1Z8"};